import apiFetch from '../apiFetch'

export default function (comment, dossierId, token) {
  return apiFetch({ endPoint: `comment?dossierId=${dossierId}`, method: 'POST', body: comment, token: token })
}
